<template>
  <section class="py-5 container">
    <h4>Factoraje - Nueva cotización</h4>
    <hr />

    <form class="card" @submit.prevent="confirmaGuardado">
      <div class="card-body">
        <h5 class="card-title">Detalles de la cotización</h5>
        <p class="card-text">
          Aquí puedes agregar los detalles de la nueva cotización de factoraje.
        </p>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Cliente</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <input
                type="text"
                v-model="state.cliente"
                placeholder="Opcional"
                class="form-control form-control-sm"
                autocomplete="off"
              />
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Línea</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <span class="input-group-text"> $ </span>
              <CurrencyInput v-model="state.linea" required />
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Monto factura</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <span class="input-group-text"> $ </span>
              <CurrencyInput v-model="state.monto_factura" required />
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Aforo (%)</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <CurrencyInput v-model="state.aforo_porcentaje" required />
              <span class="input-group-text"> % </span>
            </div>
            <p class="text-xxs mb-0 text-center mt-2">
              ${{ formatoMoneda(aforo_cantidad, false) }}
            </p>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Comisión de apertura (%)</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <CurrencyInput v-model="state.comision_apertura" required />
              <span class="input-group-text"> % </span>
            </div>
            <p class="text-xxs mb-0 text-center mt-2">
              ${{ formatoMoneda(comisionAperturaCantidad, false) }}
            </p>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Comisión por disposición</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <CurrencyInput v-model="state.comision_disposicion" required />
              <span class="input-group-text"> % </span>
            </div>
            <p class="text-xxs mb-0 text-center mt-2">
              ${{ formatoMoneda(comisionDisposicionCantidad, false) }}
            </p>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Tasa</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <CurrencyInput v-model="state.tasa" required />
            </div>
            <p class="text-xxs mb-0 text-center mt-2">
              ${{ formatoMoneda(tasaCantidad, false) }}
            </p>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Plazo</span>
          </div>
          <div class="w-25">
            <select class="form-control" v-model="state.plazo">
              <option value="30">30 días</option>
              <option value="60">60 días</option>
              <option value="90">90 días</option>
              <option value="120">120 días</option>
            </select>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Fecha de Curse</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <span class="input-group-text">
                <i class="ri ri-calendar-line me-4"></i>
              </span>
              <input
                class="form-control form-control-sm"
                type="date"
                required
                v-model="state.fecha_curse"
              />
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between py-2 border-bottom px-3"
        >
          <div>
            <span>Fecha de Pago</span>
          </div>
          <div class="w-25">
            <div class="input-group">
              <span class="input-group-text">
                <i class="ri ri-calendar-line me-4"></i>
              </span>
              <input
                class="form-control form-control-sm"
                type="date"
                required
                v-model="state.fecha_pago"
              />
            </div>
            <p class="text-xxs mb-0 text-center mt-2">{{ fechaFormateada }}</p>
          </div>
        </div>
        <div
          class="d-flex align-items-center bg-light px-3 justify-content-between py-2 border-bottom fw-bold text-lg"
        >
          <div>
            <span>Monto a recibir</span>
          </div>
          <div class="w-25 text-center">
            <span class="fw-bold text-lg"
              >${{ formatoMoneda(montoARecibir, false) }}</span
            >
          </div>
        </div>
        <ArgonAlert v-if="conceptosFueraDeRango" color="danger" class="mt-3">{{
          imprimerErrorRango()
        }}</ArgonAlert>
        <div
          class="mt-4 text-center d-flex align-items-center justify-content-center gap-2"
        >
          <ArgonButton
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="conceptosFueraDeRango"
          >
            Cotizar
          </ArgonButton>
          <ArgonButton color="light" @click="regresar"> Regresar </ArgonButton>
        </div>
      </div>
    </form>
  </section>
</template>

<script setup>
import ArgonAlert from "@/components/ArgonAlert.vue";
import CurrencyInput from "@/components/CurrencyInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {
  useCotizacionFactoraje,
  useCotizacionFactorajeSave,
} from "@/composables/useCotizacionFactoraje";
const {
  state,
  aforo_cantidad,
  montoARecibir,
  formatoMoneda,
  fechaFormateada,
  regresar,
  comisionAperturaCantidad,
  comisionDisposicionCantidad,
  tasaCantidad,
} = useCotizacionFactoraje();

const {
  confirmaGuardado,
  loading,
  imprimerErrorRango,
  conceptosFueraDeRango,
} = useCotizacionFactorajeSave();
</script>

<style scoped>
input {
  text-align: center;
}
</style>
